import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Star, ArrowRight } from 'lucide-react';
const companions = [{
  name: 'Yuki 优希',
  age: 23,
  tagline: 'Elegant and refined',
  location: 'Orchard',
  rating: 4.9,
  gradient: 'from-purple-900/40 to-blue-900/40',
  image: 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=400&h=600&fit=crop&crop=face'
}, {
  name: 'Mia 美雅',
  age: 25,
  tagline: 'Charming conversation partner',
  location: 'Marina Bay',
  rating: 4.8,
  gradient: 'from-rose-900/40 to-pink-900/40',
  image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=600&fit=crop&crop=face'
}, {
  name: 'Sakura 樱花',
  age: 22,
  tagline: 'Sweet and attentive',
  location: 'Sentosa',
  rating: 4.9,
  gradient: 'from-amber-900/40 to-orange-900/40',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=600&fit=crop&crop=face'
}, {
  name: 'Luna 露娜',
  age: 24,
  tagline: 'Sophisticated beauty',
  location: 'Clarke Quay',
  rating: 4.7,
  gradient: 'from-emerald-900/40 to-teal-900/40',
  image: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=400&h=600&fit=crop&crop=face'
}, {
  name: 'Hana 花',
  age: 21,
  tagline: 'Youthful energy',
  location: 'Bugis',
  rating: 4.8,
  gradient: 'from-indigo-900/40 to-violet-900/40',
  image: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400&h=600&fit=crop&crop=face'
}, {
  name: 'Mei Lin 美琳',
  age: 26,
  tagline: 'Mature elegance',
  location: 'Orchard',
  rating: 4.9,
  gradient: 'from-red-900/40 to-rose-900/40',
  image: 'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=400&h=600&fit=crop&crop=face'
}];
export function FeaturedCompanions() {
  return <section id="companions" className="py-24 bg-[#050505]" data-id="element-9">
      <div className="max-w-7xl mx-auto px-6" data-id="element-10">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6" data-id="element-11">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-12">
            <h2 className="text-3xl md:text-5xl font-serif text-white mb-2" data-id="element-13">
              Featured Companions
            </h2>
            <p className="text-[#c9a96e] text-xl font-serif" data-id="element-14">精选佳丽</p>
          </motion.div>

          <motion.button initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex items-center gap-2 text-neutral-400 hover:text-[#c9a96e] transition-colors group" data-id="element-15">
            <span data-id="element-16">View All Profiles</span>
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-17" />
          </motion.button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-18">
          {companions.map((companion, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group relative bg-[#111111] rounded-xl overflow-hidden border border-neutral-800 hover:border-[#c9a96e]/50 transition-all duration-500 hover:shadow-[0_0_30px_rgba(201,169,110,0.15)]" data-id="element-19">
              {/* Photo */}
              <div className={`h-80 w-full bg-gradient-to-br ${companion.gradient} relative overflow-hidden`} data-id="element-20">
                <img src={companion.image} alt={companion.name} className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700" data-id="element-21" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#111111] via-[#111111]/20 to-transparent" data-id="element-22" />

                <div className="absolute top-4 right-4 bg-black/40 backdrop-blur-md px-3 py-1 rounded-full flex items-center gap-1 border border-white/10" data-id="element-23">
                  <Star size={14} className="text-[#c9a96e] fill-[#c9a96e]" data-id="element-24" />
                  <span className="text-white text-xs font-medium" data-id="element-25">
                    {companion.rating}
                  </span>
                </div>
              </div>

              <div className="p-6 relative" data-id="element-26">
                <div className="flex justify-between items-start mb-2" data-id="element-27">
                  <h3 className="text-2xl font-serif text-white group-hover:text-[#c9a96e] transition-colors" data-id="element-28">
                    {companion.name}
                  </h3>
                  <span className="text-neutral-500 text-sm border border-neutral-800 px-2 py-1 rounded" data-id="element-29">
                    {companion.age} y/o
                  </span>
                </div>

                <p className="text-neutral-400 text-sm mb-4 italic" data-id="element-30">
                  "{companion.tagline}"
                </p>

                <div className="flex items-center gap-4 text-sm text-neutral-500 mb-6" data-id="element-31">
                  <div className="flex items-center gap-1" data-id="element-32">
                    <MapPin size={14} className="text-[#c9a96e]" data-id="element-33" />
                    <span data-id="element-34">{companion.location}</span>
                  </div>
                  <div className="w-1 h-1 bg-neutral-700 rounded-full" data-id="element-35" />
                  <span data-id="element-36">Available Today</span>
                </div>

                <button className="w-full py-3 border border-[#c9a96e]/30 text-[#c9a96e] rounded-lg hover:bg-[#c9a96e] hover:text-black transition-all duration-300 font-medium uppercase text-xs tracking-widest" data-id="element-37">
                  View Profile
                </button>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}